import { AvatarBorder } from "../AvatarBorder";
import { UserName } from "../UserName";
import { cn } from "@/lib/utils";
import type { DomainType } from "@/lib/types/api";

interface MessageProps {
  message: {
    _id: string;
    content: string;
    authorName: string;
    timestamp: number;
    authorId: string;
    authorPictureUrl?: string | null;
    authorActiveFrameUrl?: string | null;
    authorTag?: string | null;
    authorDomainType?: string | null;
  };
  isOwn: boolean;
  showAvatar: boolean;
}

export function Message({ message, isOwn, showAvatar }: MessageProps) {
  const formatTime = (timestamp: number) => {
    return new Date(timestamp).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const avatarUrl =
    message.authorPictureUrl ||
    `https://avatar.vercel.sh/${message.authorId ?? message.authorName}`;

  return (
    <div className={cn("flex items-start space-x-0 animate-fade-in")}>
      {/* Avatar */}
      <div
        className={cn(
          "shrink-0 transition-opacity mt-4",
          !showAvatar && "invisible mt-0 h-0",
        )}
      >
        <AvatarBorder
          src={avatarUrl}
          decoration={message.authorActiveFrameUrl ?? undefined}
          size={40}
        />
      </div>

      {/* Message Content */}
      <div className={`w-full items-start flex flex-col`}>
        {showAvatar && (
          <div className={cn("w-full flex justify-between items-center mt-4")}>
            <span className="text-xs text-gray-400 px-3 flex items-center gap-2">
              <UserName username={message.authorName} iconSize="size-3" domainType={message.authorDomainType as DomainType} />
              {message.authorTag && (
                <span className="px-2 pt-0.5 rounded-sm bg-[#0659B5] text-[10px] uppercase tracking-wide text-white">
                  {message.authorTag}
                </span>
              )}
            </span>
            <span className={`text-xs text-gray-400 px-3`}>
              {formatTime(message.timestamp)}
            </span>
          </div>
        )}

        <div className={`px-3 rounded-2xl text-white`}>
          <p className="text-sm leading-relaxed break-words">
            {message.content}
          </p>
        </div>
      </div>
    </div>
  );
}
